const currencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
	minimumSignificantDigits: 1, // Requried for Edge version 44.17763+
});

const thousandsStringFormatter = function thousandsStringFormatter(value) {
	return Math.abs(value) > 999
		? `${Math.sign(value) * ((Math.abs(value) / 1000).toFixed(1))}k`
		: Math.sign(value) * Math.abs(value);
};

export { currencyFormatter };
export { thousandsStringFormatter };
export default currencyFormatter;



// WEBPACK FOOTER //
// ./src/lib/formatters.js